import React from 'react'
import "./Questionsummary.css"
import Questionnumber from '../Questionnumber/Questionnumber'

function Questionsummary({ attemptedQuestions, markForReviewQuestionsArray, testQuestions, viewedQuestionsArray, setSelectedQuestionNumber, selectedQuestionNumber, handleFinishTest, finishTest, totalQuestions, attemptedAndMarkedForReview, isCUET }) {
  return (
    <>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-6 col-md-12 col-sm-12 p-2'>
            <div className='bg-whites d-flex flex-column align-items-center justify-content-center py-1'>
              <h6 className='bg-text-whites p-3 rounded-circle d-flex justify-content-center align-items-center' style={{ width: "50px" }}>{totalQuestions - viewedQuestionsArray?.length}</h6>
              <p style={{ color: '#00796b', fontWeight: '500', textAlign: "center" }} >Not Visited</p>
            </div>
          </div>
          <div className='col-lg-6 col-md-12 col-sm-12 p-2'>
            <div className='bg-lightorange d-flex flex-column align-items-center justify-content-center py-1'>
              <h6 className='bg-text-lightorange p-3 rounded-circle d-flex justify-content-center align-items-center' style={{ width: "50px" }}>{totalQuestions - attemptedQuestions?.length}</h6>
              <p style={{ color: '#00796b', fontWeight: '500', textAlign: "center" }} >Not Answered</p>
            </div>
          </div>
          <div className='col-lg-6 col-md-12 col-sm-12 p-2'>
            <div className='bg-lightgreen d-flex flex-column align-items-center justify-content-center py-1'>
              <h6 className='bg-text-lightgreen p-3 rounded-circle d-flex justify-content-center align-items-center' style={{ width: "50px" }}>{attemptedQuestions?.length}</h6>
              <p style={{ color: '#00796b', fontWeight: '500', textAlign: "center" }} >Answered</p>
            </div>
          </div>
          <div className='col-lg-6 col-md-12 col-sm-12 p-2'>
            <div className='bg-lightpurple d-flex flex-column align-items-center justify-content-center py-1'>
              <h6 className='bg-text-lightpurple p-3 rounded-circle d-flex justify-content-center align-items-center' style={{ width: "50px" }}>{markForReviewQuestionsArray?.length}</h6>
              <p style={{ color: '#00796b', fontWeight: '500', textAlign: "center" }} >Marked For Review</p>
            </div>
          </div>
          {
            isCUET && <div className='col-lg-6 col-md-12 col-sm-12 p-2'>
              <div className='d-flex flex-column align-items-center justify-content-center py-1' style={{ backgroundColor: '#e0f7f4', borderRadius: '12px' }}>
                <h6
                  className='d-flex justify-content-center align-items-center'
                  style={{
                    backgroundColor: '#625D26',
                    color: 'white',
                    padding: '12px',
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px'
                  }}
                >
                  {attemptedAndMarkedForReview?.length}
                </h6>
                <p style={{ color: '#00796b', fontWeight: '500', textAlign: "center" }} >Attemped & Marked For Review</p>
              </div>
            </div>
          }

        </div>
      </div>
      <Questionnumber setSelectedQuestionNumber={setSelectedQuestionNumber} selectedQuestionNumber={selectedQuestionNumber} /* testQuestions={testQuestions} */ attemptedQuestions={attemptedQuestions} markForReviewQuestionsArray={markForReviewQuestionsArray} attemptedAndMarkedForReview={attemptedAndMarkedForReview} viewedQuestionsArray={viewedQuestionsArray} handleFinishTest={handleFinishTest} finishTest={finishTest} totalQuestions={totalQuestions} isCUET={isCUET} />
    </>
  )
}

export default Questionsummary
